export default "__VITE_ASSET__0REensS$__"